import styles from '@buddieshr/styles/components/logoSimpleperf.module.scss';

const LogoSimplePerf = ({ white = false }) => (
  <div
    className={styles.logoSimplePerf}
    style={white ? { color: 'white' } : {}}
  >
    SimplePerf
  </div>
);

export default LogoSimplePerf;
